import axios from 'axios';

// const BASE_URL = 'https://backmern.picknow.in/api'; // Replace with your actual API URL
const BASE_URL = 'https://supportback.beeants.in/';
// const BASE_URL = 'http://localhost:7937';


const axiosInstance = axios.create({
  baseURL: BASE_URL,
  // timeout: 60000, // Increased timeout to 60 seconds for image uploads
  headers: {
    'Content-Type': 'application/json',
  },    
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage  
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Let browser set Content-Type (with boundary) when sending FormData
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
 
// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Handle 401 Unauthorized error
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh token
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          const response = await axios.post(`${BASE_URL}/auth/refresh-token`, {
            refreshToken,
          });

          const { token } = response.data;
          localStorage.setItem('token', token);

          // Retry the original request with new token
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        // If refresh token fails, logout user
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
      }
    }

    // Handle other errors
    if (error.response?.data?.message) {
      // You can handle error messages here or pass them to a notification system
      console.error('API Error:', error.response.data.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 